export default __webpack_public_path__ + "static/media/mint-video.ce4b6951.mp4";